var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductFreelancer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.9%",
    y: "-8.7%",
    width: "121.7%",
    height: "121.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.41638472e-14%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B37E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#399D6C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.50525,24.50525 C24.50525,25.1499043 23.9826543,25.6725 23.338,25.6725 C22.6933457,25.6725 22.17075,25.1499043 22.17075,24.50525 L22.17075,22.17075 C22.17075,20.2367869 20.6029631,18.669 18.669,18.669 L9.331,18.669 C7.39703688,18.669 5.82925,20.2367869 5.82925,22.17075 L5.82925,24.50525 C5.82925,25.1499043 5.30665437,25.6725 4.662,25.6725 C4.01734563,25.6725 3.49475,25.1499043 3.49475,24.50525 L3.49475,22.17075 C3.49475,18.9474782 6.10772813,16.3345 9.331,16.3345 L18.669,16.3345 C21.8922718,16.3345 24.50525,18.9474782 24.50525,22.17075 L24.50525,24.50525 Z M14,14 C10.7767281,14 8.16375,11.3870219 8.16375,8.16375 C8.16375,4.94047813 10.7767281,2.3275 14,2.3275 C17.2232718,2.3275 19.83625,4.94047813 19.83625,8.16375 C19.83625,11.3870219 17.2232718,14 14,14 Z M14,11.6655 C15.9339631,11.6655 17.50175,10.0977131 17.50175,8.16375 C17.50175,6.22978688 15.9339631,4.662 14,4.662 C12.0660369,4.662 10.49825,6.22978688 10.49825,8.16375 C10.49825,10.0977131 12.0660369,11.6655 14,11.6655 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-1-1-Analytics-Overview",
    transform: "translate(-849.000000, -885.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portlet-sales-copy-5",
    transform: "translate(835.000000, 694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(1.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(16.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#E0E0E0",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g/green",
    mask: "url(#mask-2)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/ic/user(custom)",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons/ic/user(custom)",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic/color/white",
    stroke: "none",
    fill: "none",
    mask: "url(#mask-6)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFreelancer);
export default __webpack_public_path__ + "static/media/product_freelancer.9cab72430a64f2899457aedcac2b666e.svg";
export { ForwardRef as ReactComponent };